/* eslint-disable unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react'
import clsx from 'clsx'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import HasilEvaluasi from 'app/KinerjaKSPage/pages/HasilEvaluasi'
import { SchoolProvider } from 'app/KinerjaKSPage/components/SchoolContentProvider'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { useMediaQueryHelper } from 'app/PemetaanKompetensiPage/hooks/useMediaQueryHelper'
import PageGuardKs from 'app/KinerjaKSPage/components/PageGuardKs'
import EvaluationResultV2 from 'app/KinerjaKSPage/pages/EvaluationResult/EvaluationResultV2'
import { useIsPrior2025 } from 'app/KinerjaShared/hooks/useIsPrior2025'
import { HasilPenilaianKinerja } from 'app/KinerjaKSPage/pages/HasilPenilaianKinerja'
import { parseQuery } from 'utils/router'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

type TPageParams = { version: 1 | 2; version2ShowYear: boolean; npsn?: string }

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled =
      (toggle?.['kinerja-ks-enabled'] &&
        toggle?.['kinerja-ks-dokumen-evaluasi-kinerja-enabled']) ||
      false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
    const npsn = parseQuery<string>(context?.query?.id, 'string')

    return {
      props: {
        version: toggle['kinerja-ks-dokumen-evaluasi-revamp-enabled'] ? 2 : 1,
        version2ShowYear: toggle['kinerja-ks-dokumen-evaluasi-tahunan-enabled'],
        npsn,
      },
    }
  },
})

const Page = ({
  version = 1,
  version2ShowYear = false,
  npsn,
}: PageProps & TPageParams) => {
  const { isDesktop } = useMediaQueryHelper()
  const isPriorTo2025 = useIsPrior2025()

  const isDesktopBrowser = useMemo(() => {
    return isDesktop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isPriorTo2025) {
    return (
      <PageGuardKs>
        <HasilPenilaianKinerja npsn={npsn || ''} />
      </PageGuardKs>
    )
  }

  if (version === 2) {
    return (
      <PageGuardKs>
        <SchoolProvider>
          <EvaluationResultV2 />
        </SchoolProvider>
      </PageGuardKs>
    )
  }

  return (
    <SchoolProvider>
      <div
        className={clsx('px-8 pb-8 pt-12 min-h-full', { 'print:p-0': true })}
      >
        <div
          className={clsx('max-w-7xl mx-auto', {
            'min-w-[1280px]': isDesktopBrowser,
          })}
        >
          <HasilEvaluasi />
        </div>
      </div>
    </SchoolProvider>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: false,
  printablePage: true,
}

export default Page
